import React, { Component } from "react";
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api'
const containerStyle = {
    height: '300px'
};
class GoogleMapControl extends Component {
    render() {
        return (
            <LoadScript
                googleMapsApiKey={this.props.googleMapsApiKey}>
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    zoom={15}
                    center={{ lat: this.props.latitude, lng: this.props.longitude }}>
                    <Marker position={{ lat: this.props.latitude, lng: this.props.longitude }} />
                </GoogleMap>
            </LoadScript>
        );
    }
}

export default GoogleMapControl;


// WEBPACK FOOTER //
// ./src/views/controls/GoogleMapControl.js